<template>
  <div class="page" :class="{ 'page__has-bar': !readonly }">
    <div class="page__bd">
      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__hd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">单号</label>
            <em class="weui-form-preview__value">{{ form.main.cc_code }}</em>
          </div>
        </div>
      </div>
      <div class="form-preview weui-form-preview">
        <div class="weui-panel__hd">基础信息</div>
        <div class="weui-form-preview__bd">
          <change-field
            label="客户名称"
            :old-value="form.main.cc_cuname_old"
            :new-value="form.main.cc_cuname_new"
          />
          <change-field
            label="客户类型"
            :old-value="form.main.cc_cutype_old"
            :new-value="form.main.cc_cutype_new"
          />
          <change-field
            label="开户银行"
            :old-value="form.main.cc_bankcode_old"
            :new-value="form.main.cc_bankcode_new"
          />
          <change-field
            label="银行账号"
            :old-value="form.main.cc_bankaccount_old"
            :new-value="form.main.cc_bankaccount_new"
          />
          <change-field
            label="开票地址"
            :old-value="form.main.cc_invoiceinfo_old"
            :new-value="form.main.cc_invoiceinfo_new"
          />
          <change-field
            label="行业类型"
            :old-value="form.main.cc_industry_new"
            :new-value="form.main.cc_industry_new"
          />
          <change-field
            label="商机线索"
            :old-value="form.main.cc_source_old"
            :new-value="form.main.cc_source_new"
          />
        </div>
      </div>
      <div class="form-preview weui-form-preview">
        <div class="weui-panel__hd">交易信息</div>
        <div class="weui-form-preview__bd">
           <change-field
            label="交易币别"
            :old-value="form.main.cc_currency_old"
            :new-value="form.main.cc_currency_new"
          />
          <change-field
            label="税率"
            :old-value="form.main.cc_taxrate_old"
            :new-value="form.main.cc_taxrate_new"
          />
          <change-field
            label="信用额度" :oldUnit="CURRENCY_SYMBOLS[defaultCurrency] || '$'" :newUnit="CURRENCY_SYMBOLS[defaultCurrency] || '$'"
            :old-value="form.main.cc_credit_old"
            :new-value="form.main.cc_credit_new"
          />
          <change-field
            label="收款方式"
            :old-value="form.main.cc_payments_old"
            :new-value="form.main.cc_payments_new"
          />
          <change-field
            label="收款延迟天数"
            :old-value="form.main.cc_paydelay_old"
            :new-value="form.main.cc_paydelay_new"
          />
          <change-field
            label="收款方式1"
            :old-value="form.main.cc_payments1_old"
            :new-value="form.main.cc_payments1_new"
          />
          <change-field
            label="收款延迟天数1"
            :old-value="form.main.cc_paydelay1_old"
            :new-value="form.main.cc_paydelay1_new"
          />
          <change-field
            label="收款方式2"
            :old-value="form.main.cc_payments2_old"
            :new-value="form.main.cc_payments2_new"
          />
          <change-field
            label="收款延迟天数2"
            :old-value="form.main.cc_paydelay2_old"
            :new-value="form.main.cc_paydelay2_new"
          />
         
          <change-field
            label="业务员"
            :old-value="form.main.cc_sellername_old"
            :new-value="form.main.cc_sellername_new"
          />
          <change-field
            label="其他业务员"
            :old-value="form.main.cc_othersellers_old"
            :new-value="form.main.cc_othersellers_new"
          />
          
        </div>
      </div>
      <div class="form-preview weui-form-preview">
        <div class="weui-panel__hd">变更信息</div>
        <div class="weui-form-preview__bd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">变更人</label>
            <span class="weui-form-preview__value">{{
              form.main.creatorName
            }}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">审核人</label>
            <span class="weui-form-preview__value">{{
              form.main.cc_auditman
            }}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">变更原因</label>
            <span class="weui-form-preview__value">{{
              form.main.cc_reason
            }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import form from "@/mixins/form.js";
import ChangeField from "@/components/field/ChangeField";

export default {
  mixins: [form],
  components: {
    ChangeField,
  },
  data() {
    return {
      baseUrl: "/api/customer/change",
      CURRENCY_SYMBOLS: {
        'RMB': '￥',
        'CNY': '￥',
        'EUR': '€',
        'HKD': 'HK$',
        'JPY': 'J￥',
        'USD': '$',
        'NTD': 'NT$',
    },
    defaultCurrency:'USD'
    };
  },
  mounted() {
    this.loadData();
  },
  methods:{
    loadData() {
      var me = this;
      me.$loading({
        url: "/api/commons/configs/getConfigByCode",
        params: {
          code: "defaultCurrency"
        }
      }).then(function(res) {
        if (res.success) {
          me.defaultCurrency = res.data.data;
        } else {
          me.$weui.topTips(res.message, 3000);
        }
      });
    },
  }
};
</script>